<template>
  <div>
    <v-dialog v-model="ui.display" persistent>
      <v-card v-if="interf.reference != null">
        <v-toolbar dense color="primary" dark align="center">
          <v-row>
            <v-col cols="5" align="left">
              <v-toolbar-title>Registri, variabili e allarmi</v-toolbar-title>
            </v-col>
            <v-col cols="2">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" small light @click="save">
                    <v-icon color="success">mdi-floppy</v-icon>
                  </v-btn>
                </template>
                <span>Salva </span>
              </v-tooltip>
            </v-col>
            <v-col cols="1"> </v-col>
            <v-col cols="1">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    light
                    @click="createUpload"
                  >
                    <v-icon color="purple">mdi-arrow-right</v-icon>
                  </v-btn>
                </template>
                <span>Esporta variabili nel modello di caricamento </span>
              </v-tooltip>
            </v-col>
            <v-col :cols="1">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    light
                    @click="configExport"
                  >
                    <v-icon color="indigo">mdi-table-arrow-down</v-icon>
                  </v-btn>
                </template>
                <span>Scarica le variabili nel file xlsx </span>
              </v-tooltip>
            </v-col>
            <v-col :cols="1">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    light
                    @click="configImport"
                  >
                    <v-icon color="success">mdi-table-arrow-up</v-icon>
                  </v-btn>
                </template>
                <span>carica la variabile dalla macchina locale </span>
              </v-tooltip>
            </v-col>
            <v-col cols="1">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" small light @click="close">
                    <v-icon color="error">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>cancella </span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-toolbar>
        <v-container>
          <v-tabs-items v-model="ui.tab">
            <!-- Registri -->
            <v-tab-item v-for="(source, i) in ui.tables" :key="i">
              <div>
                <v-toolbar dense color="primary" rounded dark>
                  <v-row align="center">
                    <v-col cols="1" align="left" v-if="ui.tab > 0">
                      <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            light
                            @click="ui.tab = ui.tab <= 0 ? 0 : ui.tab - 1"
                          >
                            <v-icon color="primary">mdi-arrow-left</v-icon>
                          </v-btn>
                        </template>
                        <span>Indietro</span>
                      </v-tooltip>
                    </v-col>
                    <v-col :cols="ui.tab > 0 ? 4 : 5" align="left">
                      <v-toolbar-title>{{ source.title }}</v-toolbar-title>
                    </v-col>
                    <v-col :cols="ui.tab == 1 ? 1 : 2">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            light
                            @click="addItem(source)"
                          >
                            <v-icon color="success">mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>Crea Nuovo</span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="1" v-if="ui.tab == 1">
                      <v-btn
                        small
                        light
                        @click="
                          $refs.dialog_test_valori.open(
                            source.caller,
                            source.src
                          )
                        "
                      >
                        <v-icon color="indigo">mdi-test-tube</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col cols="3" v-if="ui.tab == 1">
                      <v-checkbox
                        label="Registro Testato"
                        readonly
                        class="mt-5"
                        v-model="tempItem.tested"
                      >
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-toolbar>
                <div style="overflow-y: auto; max-height: calc(80vh - 120px)">
                  <v-data-table
                    :headers="headers[source.context]"
                    :items="source.src"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:body="{ items }">
                      <tbody>
                        <tr v-for="(item, j) in items" :key="j">
                          <td
                            v-for="(field, j) in headers[source.context]"
                            :key="j"
                          >
                            <template v-if="field.text != null">
                              <DynamicInput
                                v-model="item[field.value]"
                                :type="field.type"
                                :items="field.values"
                                :label="field.text"
                              />
                            </template>
                            <template v-if="field.text == null">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    light
                                    @click="field.callback(item, source.src)"
                                  >
                                    <v-icon :color="field.color">{{
                                      field.icon
                                    }}</v-icon>
                                  </v-btn>
                                </template>
                                <span>{{ field.tooltiptext }}</span>
                              </v-tooltip>
                            </template>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-data-table>
                </div>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-container>
      </v-card>
    </v-dialog>
    <DialogTestValori
      @selection="importSelection"
      v-if="interf.reference != null"
      :module_schema="interf.selected_module"
      ref="dialog_test_valori"
      :interface_id="interf.reference.interface_id"
      :gateway_id="gateway_id"
      :machine_id="machine_id"
    />
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>
<script>
import DynamicInput from "../.common/DynamicInput.vue";
import DialogTestValori from "./DialogTestValori.vue";
import XLSX from "xlsx";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
export default {
  name: "DialogRegistriMacchina",
  components: {
    DialogTestValori,
    DynamicInput,
    SnackbarQV,
  },
  props: {
    schema: Object,
    gateway_id: Number,
    machine_id: Number,
  },
  data() {
    return {
      registerTest: true,
      errDlg: false,
      tempItem: { tested: false },
      uid_counter: 0,
      headers: {
        register: new Array(),
        variable: new Array(),
        alarm: new Array(),
      },
      interf: {
        clone: null,
        reference: null,
        selected_module: null,
      },
      ui: {
        display: false,
        tab: 0,
        tables: [
          {
            title: "Registri",
            caller: null,
            context: "register",
            src: null,
            inner: "variables",
            named: false,
          },
          {
            title: "Variabili",
            caller: null,
            context: "variable",
            src: null,
            inner: "alarms",
            named: true,
          },
          {
            title: "Allarmi",
            caller: null,
            context: "alarm",
            src: null,
            inner: null,
            named: false,
          },
        ],
      },
    };
  },
  methods: {
    checkSaveDisabled() {
      console.log(this.ui.tables[0].src);
      if (this.registerTest == false) {
        return false;
      }
      var temp = false;
      this.ui.tables[0].src.forEach((e) => {
        if (e.tested == false) {
          temp = true;
        }
      });
      return temp;
    },
    createUpload() {
      this.interf.clone.upload_templates = [];
      this.interf.clone.registers.forEach((r) => {
        r.variables.forEach((v) => {
          this.interf.clone.upload_templates.push({
            column_index: 0,
            template: "{" + v._uid + "}",
            upload_name: v._name,
            variables: [v._uid],
          });
        });
      });
      this.$refs.SnackbarQV.print(
        "success",
        "Template di upload creato con sucesso"
      );
    },
    addItem(table) {
      const item = new Object();
      item[table.inner] = new Array();
      for (let i = 0; i < this.headers[table.context].length; i++) {
        const template = this.headers[table.context][i];
        if (template.text == null) {
          continue;
        }
        item[template.value] = template.default_value;
      }
      item._uid = ++this.uid_counter;
      if (table.context == "register") item.tested = false;
      table.src.push(item);
    },
    close() {
      this.ui.display = false;
      while (this.headers.register.length > 0) {
        this.headers.register.splice(0, 1);
      }
      while (this.headers.variable.length > 0) {
        this.headers.variable.splice(0, 1);
      }
      while (this.headers.alarm.length > 0) {
        this.headers.alarm.splice(0, 1);
      }
      Object.assign(this.interf, {
        reference: null,
        clone: null,
        selected_module: null,
      });
      this.resetTableSources();
      this.ui.tab = 0;
      this.uid_counter = 0;
    },
    configExport() {
      const data = {
        register: new Array(),
        variable: new Array(),
        alarm: new Array(),
      };
      for (let i = 0; i < this.ui.tables.length; i++) {
        const table = this.ui.tables[i];
        const item = new Object();
        for (let j = 0; j < this.headers[table.context].length; j++) {
          const template = this.headers[table.context][j];
          if (template.text == null) {
            continue;
          }
          item[template.value] = template.text + " [[" + template.value + "]]";
        }
        if (i > 0) {
          item._ref = "Riferimento [[_ref]]";
        }
        item._uid = "ID [[_uid]]";
        data[table.context].push(item);
      }

      const registers_src = this.interf.clone.registers;
      for (let i = 0; i < registers_src.length; i++) {
        const register = Object.assign({}, registers_src[i]);
        for (let j = 0; j < register.variables.length; j++) {
          const variable = Object.assign({}, register.variables[j]);
          variable._ref = register._uid;
          for (let k = 0; k < variable.alarms.length; k++) {
            const alarm = Object.assign({}, variable.alarms[k]);
            alarm._ref = variable._uid;
            data.alarm.push(alarm);
          }
          delete variable.alarms;
          data.variable.push(variable);
        }
        delete register.variables;
        data.register.push(register);
      }
      const register_sheet = XLSX.utils.json_to_sheet(data.register, {
        header: ["_uid"],
        skipHeader: true,
      });
      const variable_sheet = XLSX.utils.json_to_sheet(data.variable, {
        header: ["_uid", "_ref", "_name"],
        skipHeader: true,
      });
      const alarm_sheet = XLSX.utils.json_to_sheet(data.alarm, {
        header: ["_uid", "_ref"],
        skipHeader: true,
      });

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        workbook,
        register_sheet,
        this.ui.tables[0].title
      );
      XLSX.utils.book_append_sheet(
        workbook,
        variable_sheet,
        this.ui.tables[1].title
      );
      XLSX.utils.book_append_sheet(
        workbook,
        alarm_sheet,
        this.ui.tables[2].title
      );

      XLSX.writeFile(workbook, this.interf.clone.interface_name + ".xlsx");
    },
    configImport() {
      const that = this;
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute(
        "accept",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      );
      input.onchange = function () {
        const reader = new FileReader();
        reader.onload = function () {
          const marker = ";base64,";
          const index = reader.result.indexOf(marker) + marker.length;
          const data = reader.result.substring(index);
          const workbook = XLSX.read(data, { type: "base64" });

          const imported_data = new Object();
          const uids = new Array();
          let max_uid = 0;
          try {
            for (let i = 0; i < that.ui.tables.length; i++) {
              const table = that.ui.tables[i];
              imported_data[table.context] = new Array();
              const sheet_source = XLSX.utils.sheet_to_json(
                workbook.Sheets[table.title]
              );
              for (let j = 0; j < sheet_source.length; j++) {
                const item = new Object();
                if (table.inner != null) {
                  item[table.inner] = new Array();
                }
                const register_src = sheet_source[j];
                const keys = Object.keys(register_src);
                for (let k = 0; k < keys.length; k++) {
                  const key = keys[k];
                  const index = key.indexOf("[[") + 2;
                  const end = key.indexOf("]]");
                  item[key.substring(index, end)] = register_src[key];
                }

                item._uid = that.getNumber(item._uid);
                if (!isFinite(item._uid) || item._uid <= 0) {
                  throw `Foglio '${table.title}': ID elemento non valido (${item._uid})`;
                }
                if (uids.indexOf(item._uid) >= 0) {
                  throw `Foglio '${table.title}': ID elemento duplicato (${item._uid})`;
                }
                max_uid = Math.max(item._uid, max_uid);
                uids.push(item._uid);

                that.configVerifyHeaders(item, table.context);
                imported_data[table.context].push(item);
              }
            }
            for (let i = 1; i < that.ui.tables.length; i++) {
              const table = that.ui.tables[i];
              const previous_table = that.ui.tables[i - 1];
              for (let j = 0; j < imported_data[table.context].length; j++) {
                const item = imported_data[table.context][j];
                let parent_found = false;
                for (
                  let k = 0;
                  k < imported_data[previous_table.context].length;
                  k++
                ) {
                  const parent_item = imported_data[previous_table.context][k];
                  if (parent_item._uid == item._ref) {
                    parent_item[previous_table.inner].push(item);
                    parent_found = true;
                    delete item._ref;
                    break;
                  }
                }
                if (!parent_found) {
                  throw `Foglio '${table.title}', ID '${item._uid}': Impossibile trovare il riferimento '${item._ref}' nel foglio '${previous_table.title}'`;
                }
              }
            }
            that.ui.tab = 0;
            that.interf.clone.registers = imported_data.register;
            that.ui.tables[0].src = imported_data.register;
            that.uid_counter = max_uid;
            alert("Import eseguito con successo");
          } catch (error) {
            alert(error);
          }
        };
        reader.readAsDataURL(input.files[0]);
      };
      input.click();
    },
    configVerifyHeaders(item, context) {
      try {
        const headers = this.headers[context];
        for (let i = 0; i < headers.length; i++) {
          const header = headers[i];
          if (header.text == null) {
            continue;
          }
          if (item[header.value] === undefined) {
            throw `Campo '${header.text}' mancante`;
          }
          const value = item[header.value];
          switch (header.type) {
            case "boolean":
              {
                if (value == null) {
                  throw `Impossibile interpretare il valore del campo '${header.text}' come boolean`;
                }
                switch (value.toString().toLowerCase().trim()) {
                  case "false":
                  case "0":
                    item[header.value] = false;
                    break;
                  case "true":
                  case "1":
                    item[header.value] = true;
                    break;
                  default:
                    throw `Impossibile interpretare il valore del campo '${header.text}' come boolean`;
                }
              }
              break;
            case "number":
              if (!isFinite(this.getNumber(value))) {
                throw `Il formato del campo '${header.text}' deve essere numerico`;
              }
              break;
            case "enum":
              {
                const e_value = this.getNumber(value);
                let found = false;
                for (let k = 0; k < header.values.length; k++) {
                  if (e_value == header.values[k].value) {
                    found = true;
                    break;
                  }
                }
                if (!found) {
                  throw `Valore non valido o non presente tra le opzioni per il campo '${header.text}'`;
                }
              }
              break;
            default:
              continue;
          }
        }
      } catch (error) {
        const tables = this.ui.tables;
        let sheet = "?";
        for (let i = 0; i < tables.length; i++) {
          if (tables[i].context == context) {
            sheet = tables[i].title;
            break;
          }
        }
        throw `Foglio '${sheet}', ID ${item._uid}: ${error}`;
      }
    },
    deleteItem(item, source) {
      const index = source.indexOf(item);
      if (index >= 0) {
        source.splice(index, 1);
      }
    },
    getHeaders(field, selected_module, goto_arrow) {
      const tables = this.ui.tables;
      for (let i = 0; i < tables.length; i++) {
        console.log(tables[i]);
        if (tables[i].context == field) {
          const table = tables[i];
          if (table.named) {
            this.headers[field].push({
              text: "Nome",
              value: "_name",
              type: "string",
              default_value: null,
            });
          }
          break;
        }
      }
      const fieldname = field + "_fields";
      for (let i = 0; i < this.schema.default_fields[fieldname].length; i++) {
        const template = this.schema.default_fields[fieldname][i];
        this.headers[field].push({
          text: template.name,
          value: template.field,
          type: template.type,
          values: template.values,
          default_value: template.default_value,
        });
      }
      for (let i = 0; i < selected_module[fieldname].length; i++) {
        const template = selected_module[fieldname][i];
        this.headers[field].push({
          text: template.name,
          value: template.field,
          type: template.type,
          values: template.values,
          default_value: template.default_value,
        });
      }
      this.headers[field].push({
        text: null,
        value: "_delete",
        callback: this.deleteItem,
        icon: "mdi-delete",
        color: "error",
        tooltiptext: "cancella",
      });
      if (goto_arrow) {
        this.headers[field].push({
          text: null,
          value: "_goto",
          callback: this.goToNext,
          icon: "mdi-arrow-right-circle",
          color: "teal",
          tooltiptext: "vai alla pagina successiva",
        });
      }
    },
    getNumber(value) {
      if (value == null) {
        return NaN;
      }
      return Number(value);
    },
    getUid(item) {
      const result = Number(item);
      if (!isFinite(result)) {
        return 0;
      } else {
        return result;
      }
    },
    goToNext(item) {
      console.log(item);
      const next_index = this.ui.tab + 1;
      const field = this.ui.tables[this.ui.tab].inner;
      this.tempItem = item;
      this.ui.tables[next_index].src = item[field];
      this.ui.tables[next_index].caller = item;
      this.ui.tab++;
    },
    findModuleById(id) {
      const modules = this.schema.modules;
      for (let i = 0; i < modules.length; i++) {
        const module = modules[i];
        if (module.id_modulo == id) {
          return module;
        }
      }
      return null;
    },
    importSelection(data) {
      const target_keys = new Array();
      for (let i = 0; i < this.headers.variable.length; i++) {
        const template = this.headers.variable[i];
        if (template.text == null) {
          continue;
        }
        if (template.value == "_name") {
          continue;
        }
        target_keys.push(template.value);
      }

      const variables = this.ui.tables[1].src;
      for (let i = 0; i < data.length; i++) {
        const conf_item = data[i];
        for (let j = 0; j < variables.length; j++) {
          const variable = variables[j];
          if (conf_item._uid != variable._uid) {
            continue;
          }
          for (let z = 0; z < target_keys.length; z++) {
            const key = target_keys[z];
            variable[key] = conf_item.data[key];
          }
        }
      }
    },
    open(interf) {
      console.log(interf);
      this.registerTest = interf.register_test;
      const selected_module = this.findModuleById(interf.module_id);
      if (selected_module == null) {
        return;
      }

      this.uid_counter = 0;
      for (let i = 0; i < interf.registers.length; i++) {
        const register = interf.registers[i];
        this.uid_counter = Math.max(
          this.uid_counter,
          this.getUid(register._uid)
        );
        for (let j = 0; j < register.variables.length; j++) {
          const variable = register.variables[j];
          this.uid_counter = Math.max(
            this.uid_counter,
            this.getUid(variable._uid)
          );
          for (let k = 0; k < variable.alarms.length; k++) {
            const alarm = variable.alarms[k];
            this.uid_counter = Math.max(
              this.uid_counter,
              this.getUid(alarm._uid)
            );
          }
        }
      }

      this.resetTableSources();
      Object.assign(this.interf, {
        reference: interf,
        clone: JSON.parse(JSON.stringify(interf)),
        selected_module: selected_module,
      });

      this.getHeaders("register", selected_module, true);
      this.getHeaders("variable", selected_module, true);
      this.getHeaders("alarm", selected_module, false);

      this.ui.tables[0].src = this.interf.clone.registers;
      this.ui.tab = 0;
      this.ui.display = true;
    },
    resetTableSources() {
      for (let i = 0; i < this.ui.tables.length; i++) {
        this.ui.tables[i].src = null;
      }
    },
    save() {
      var temp = this.checkSaveDisabled();
      console.log(temp);
      if (!temp) {
        this.interf.reference.registers = this.interf.clone.registers;
        this.interf.reference.upload_templates =
          this.interf.clone.upload_templates;
        this.close();
      } else {
        this.$refs.SnackbarQV.print(
          "error",
          "Impossibile salvare, ci sono registri non testati"
        );
      }
    },
  },
};
</script>